<template>
	<div>
		<div id="shopping-cart-btn" class="shadow" v-show="showBottomCart">
			<button
				class="btn"
				@click.prevent="show(true)"
			>
				<i class="fa fa-shopping-cart fa-2x"></i>
				<!--<span class="material-icons md-30">shopping_cart</span>-->
			</button>
			<span class="shopping-badge badge badge-pill badge-primary">
				{{ inCart.length }}
			</span>
		</div>
		
		<div class="cart-overlay" v-show="showCart" @click.prevent="show(false)"></div>
		
		<transition name="shopcart">
			<div class="cart" v-show="showCart" v-body-scroll-lock="showCart">
				<div class="cart-inner">
					<div class="container-fluid">
						<div class="row d-flex justify-content-center mt-2 mb-3">
							<div class="col-12 mt-3">
								<div class="alert alert-info text-center" v-show="inCart.length === 0">
									<p class="h4">
										A kosarad üres
									</p>
								</div>
							</div>
							<div class="col-12">
								<div class="row d-flex justify-content-center" v-show="inCart.length !== 0">
									<cart-item
										class="col-12"
										v-for="(v,k) in inCart"
										:key="k"
										:item="v"
										:index="k"
									>
									</cart-item>
									<div class="col-12 h5">
										Összesítés:
										{{numInCart}} db termék {{cartSum}} Ft összegben
									</div>
									<div class="col-6">
										<button
											class="btn btn-outline-danger btn-lg m-2"
											@click.prevent="removeCart"
										>
											Kosár ürítése
										</button>
									</div>
									<div
										class="col-6"
										:class="[numInCart == 0 ? 'disabled' : '']"
									>
										<router-link
											class="btn btn-outline-success btn-lg m-2"
											:to="'/orders/ordersum'"
										>
											Véglegesítés
											<i class="fa fa-chevron-right"></i>
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script type="text/javascript">
import cartItem from '@/components/cart/cartItem_v2'
import {mapGetters,mapActions} from 'vuex'
export default {
	props: ['nav'],

	components: {
		cartItem
	},

	data() {
		return {
			showCart: false,
			//delivery : 0
		}
	},

	methods: {
		...mapActions(['removeCart','removeFromCart','addToCart','rFromCart','pToCart']),

		show(x) {
			this.showCart = x
		},

		handleScroll() {
			var el = document.getElementById('shopping-cart-btn')
			if (window.pageYOffset >= 140) {
          		el.style.opacity = '1'
          		el.style.transform = 'scale(1)'
        	} else {
        		el.style.opacity = '0'
          		el.style.transform = 'scale(1)'
        	}
		},
	},

	computed: {
		...mapGetters(['inCart','cartSum']),
		
		numInCart() {
			return this.inCart.reduce((total, current) => total + ~~current.db, 0)
		},

		showBottomCart() {
			if(this.inCart.length > 0) return true
			return false
		}
	},

	watch: {
		'$route'() {
			this.show(false)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/cart/cart_v2.vue